import TrackReturnPage from '@modules/tracking/pages/TrackReturnPage';

export default TrackReturnPage;
